import { useEffect } from "react";

const BASE_TITLE = "LOFINO Backoffice";

export default function usePageTitle(title?: string) {
	useEffect(() => {
		document.title = title ? `${title} – ${BASE_TITLE}` : BASE_TITLE;
	}, [title]);
}
